'use client'

import { RightIcon } from '@/app/[locale]/_assets/icon-components'
import { ICategory } from '@/app/[locale]/_types'
import { Button, Center, Spinner } from '@chakra-ui/react'
import { useTranslations } from 'next-intl'
import React from 'react'

const Mobile = ({
  hasNextPage,
  data,
  count,
  fetchNextPage,
  isFetchingNextPage,
  showImage,
}: {
  showImage: boolean
  hasFilter?: boolean
  count?: number | string
  hasNextPage?: boolean
  fetchNextPage?: () => void
  data: ICategory[]
  isFetchingNextPage?: boolean
}) => {
  const t = useTranslations()

  if (hasNextPage && data.length < Number(count)) {
    if (showImage) {
      return (
        <Center
          mr={4}
          gap={2}
          cursor={'pointer'}
          onClick={() => fetchNextPage?.()}
          display={{ base: 'flex', lg: 'none' }}
        >
          <Center
            gap={2}
            width='40px'
            height='40px'
            shadow={'sm'}
            rounded={'full'}
          >
            {isFetchingNextPage ? (
              <Spinner size={'sm'} color={'primary'} />
            ) : (
              <RightIcon />
            )}
          </Center>
        </Center>
      )
    }
    return (
      <Button
        rounded={12}
        fontSize='sm'
        variant='ghost'
        fontWeight={500}
        loading={isFetchingNextPage}
        disabled={isFetchingNextPage}
        onClick={() => fetchNextPage?.()}
        display={{ base: 'flex', lg: 'none' }}
      >
        {t('more')}
      </Button>
    )
  }

  return null
}

export default Mobile
